// extracted by mini-css-extract-plugin
module.exports = {"changeImageLabel":"ImageUpload_changeImageLabel__2inEQ","changeImageInput":"ImageUpload_changeImageInput__3wSQB"};